import { createStore, type Store } from "@quotientjs/browser-storage"
import { z } from "zod"

export const REFERRER_STORAGE_KEY = "quotient-referrer-url"

/**
 * Stores the page that sent the visitor when the current session started.
 * It uses `localStorage` so other tabs in the session can use the same value.
 */
export const ReferrerStore: Store<string, "local"> = createStore({
  key: REFERRER_STORAGE_KEY,
  validator: z.string(),
  storageType: "local",
})
